import { FC, PropsWithChildren } from 'react';

type Props = {
	className?: string;
};

const TanzaniaFlagIcon: FC<PropsWithChildren<Props>> = ({ className }) => {
	return (
		<svg
			width='20'
			height='14'
			viewBox='0 0 20 14'
			fill='none'
			xmlns='http://www.w3.org/2000/svg'
			className={`${className}`}>
			<rect
				width='20'
				height='14'
				rx='2'
				fill='white'
			/>
			<mask
				id='mask0_2332_16002'
				style={{ maskType: 'luminance' }}
				maskUnits='userSpaceOnUse'
				x='0'
				y='0'
				width='20'
				height='14'>
				<rect
					width='20'
					height='14'
					rx='2'
					fill='white'
				/>
			</mask>
			<g mask='url(#mask0_2332_16002)'>
				<path
					fillRule='evenodd'
					clipRule='evenodd'
					d='M0 9.33333L20 0H0V9.33333Z'
					fill='#33CC4D'
				/>
				<path
					fillRule='evenodd'
					clipRule='evenodd'
					d='M0 14H20V4.66663L0 14Z'
					fill='#2DAFE4'
				/>
				<path
					fillRule='evenodd'
					clipRule='evenodd'
					d='M2.20144 15.8667L21.5502 4.01801L17.798 -1.8667L-1.55078 9.98197L2.20144 15.8667Z'
					fill='#FFD84F'
				/>
				<path
					fillRule='evenodd'
					clipRule='evenodd'
					d='M-0.449231 16.1503L22.9731 1.80717L20.4496 -2.15039L-2.97266 12.1928L-0.449231 16.1503Z'
					fill='#262626'
				/>
			</g>
		</svg>
	);
};

export default TanzaniaFlagIcon;
